
// Utility functions for detecting and handling iframe context
export const isInIframe = (): boolean => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true; // If we can't access window.top, we're likely in an iframe
  }
};

export const isLovablePreview = (): boolean => {
  try {
    return window.location.hostname.includes('lovable.app') || 
           window.location.hostname.includes('gptengineer.app');
  } catch (e) {
    return false;
  }
};

export const shouldUsePopupAuth = (): boolean => {
  return isInIframe() && isLovablePreview();
};

export const openPopoutWindow = (): void => {
  const currentUrl = window.location.origin;
  window.open(currentUrl, '_blank', 'noopener,noreferrer');
};
